export enum ApplicationActionsMenuVariant {
  Group = "group",
  Detail = "detail"
}
